// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","version":"Footer_version__dxgP9","logo":"Footer_logo__+SElo"};